import { TemplateData, TemplateParams } from '.';

const pathSummary = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathAdminUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        {{summaryContent}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.emailTypePathSummary} ({{pathTitle}})`
  },
  placeholders: {
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathAdminUrl: {
      label: messages.pathsPathAdminLink,
      example: `${serverConfig.adminUrl}/admin/paths/1`
    },
    summaryContent: {
      label: messages.emailSummaryOfPathEvents
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathSummary
});

export default pathSummary;
